<template>
    <div id="filter_data_container_img" :class="[filter_name]">
        <div id="filter_data_container">
            <a id="exitArrow" @click="$store.commit('updateFilterSelectOpen', '')"> <!--.prevent.stop="$store.commit('updateFilterSelectOpen', '')"> -->
                &#10094;   
            </a>

            <div id="filter_data_container_title">
                Narrow Your Search By 
                <br v-if="saveVerticalSpace"/>
                {{  getFilterDisplay }}
            </div>
            
			<div id="filterSelectionDisplay" :class="[filterType]">
                <single-range-select v-if="filter_name == 'back_of_book'" :filterName="filter_name"/>
                <quick-filter-select v-else-if="filter_name == 'quick_filters'"/>
                <range-select v-else-if="filterType == 'range'" :filterName="filter_name"/>
                <list-select v-else-if="filterType == 'object' || filterType == 'array'" :filterName="filter_name"/>
            </div>

            <div id="filterPopupFooter">
                <div id='CurrentFilterResults'>
                    <span id='CurrentResultsNumber'>
                        {{ formatNumber($store.getters.getTotalMatches) }}
                    </span> 
                    <span id='ResultSeperator'>
                        matches out of
                    </span> 
                    <span id='MaxResultsNumber'>
                        {{ formatNumber($store.getters.getTotalVehicleCount) }} vehicles
                    </span>
                </div>
                
                <div id="filter_controls">
                    <div class="toPreviousFilter navArrow" v-on="previousFilter ? { click: goToPreviousFilter } : {}" :class="[!previousFilter ? 'notClickable' : '']">
                        &#10094; Previous
                    </div>
                    <div id="viewButton">
                        <div class="update" id="continue_results" @click.prevent.stop="viewResults">
                            VIEW
                        </div>
                    </div>
                    <div class="toNextFilter navArrow" v-on="nextFilter ? { click: gotToNextFilter } : {}" :class="[nextFilter ? '' : 'notClickable']">
                        Next &#10095;
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
    import QuickFilterSelect from './QuickFilterSelect.vue';
    import RangeSelect from './RangeSelect.vue';
    import SingleRangeSelect from './SingleRangeSelect.vue';
    import ListSelect from './ListSelect.vue';

    export default {
        mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },
        unmounted() {
            document.removeEventListener('click', this.handleClickOutside)
        },
        components: {
            'quick-filter-select': QuickFilterSelect,
            'range-select': RangeSelect,
            'single-range-select': SingleRangeSelect,
            'list-select': ListSelect
        },
        computed: {
            filter_name() {
                return this.$store.getters.getFilterSelectOpen;
            },
            filterType() {
                return this.$store.getters.getAvailableFilters[this.filter_name].type;
            },
            getFilterDisplay() {
                return this.$store.getters.getAvailableFilters[this.filter_name].displayString;
            },
            nextFilter() {
                let nextSib = document.getElementById(this.filter_name).nextElementSibling;

                if(nextSib && (!nextSib.classList.contains('filterContainer') || this.$store.getters.getAvailableFilters[nextSib.id].type == 'boolean')) {
                    nextSib = null;
                }

                return nextSib;
            },
            previousFilter() {
                return document.getElementById(this.filter_name).previousElementSibling;
            },
            saveVerticalSpace() {
                return this.$store.getters.isMobile || !['makes', 'models'].includes(this.filter_name);
            }
        },
        methods: {
            closeFilterPopup() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('close', {'event_category': 'filter_modal','event_label': eventLabel});
                this.$store.commit('updateFilterSelectOpen', '');
            },
            handleClickOutside(evt) {
                if (!this.$el.contains(evt.target)) {
                    if(this.$store.getters.isFilterSelectOpen) {
                        this.closeFilterPopup();
                    }
                }
            },
            viewResults() {
                if(this.$store.getters.isMobile) {
                    this.$store.commit('updateShowMobileVehicleResultsStatus', true);
                }
                    
                this.closeFilterPopup();
            },
            goToPreviousFilter() {
                if(this.previousFilter) {
                    let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                    this.$gtag.event('previous', {'event_category': 'filter_modal','event_label': eventLabel});
                    this.previousFilter.click();
                }
            },
            gotToNextFilter() {
                if(this.nextFilter) {
                    let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                    this.$gtag.event('next', {'event_category': 'filter_modal','event_label': eventLabel});
                    this.nextFilter.click();
                }
            },
            formatNumber(number) {
                var nf = Intl.NumberFormat();
                 
                return nf.format(number);
            }
        }
	}
</script>

<style>
    #filter_data_container_img {
        z-index: 3;
        min-width: calc(30 * var(--vw));
        max-width: calc(86 * var(--vw));
        height: fit-content;
        width: fit-content;
        position: absolute;
        left: calc(9.6 * var(--vw));
        top: calc(22 * var(--vh));
        background: linear-gradient(#DFDFDF, #FFFFFF);
        border: solid #8291A0 thin;
        box-shadow: 3px 6px 6px -2px #8291A0;
        border-radius: calc(var(--vratio) * 2 * var(--vh));/*10px;*/
    }

    #filter_data_container_img .largeList {
        width: calc(86 * var(--vw));
    }

    #filter_data_container_img.makes,
    #filter_data_container_img.models {
        top: calc(4 * var(--vh));
    }

    .inmobile #filter_data_container_img {
        left: calc(2 * var(--vw));
        top: calc(1 * var(--vh));
        width: calc(96 * var(--vw));
        max-width: calc(96 * var(--vw));
        height: calc(98 * var(--vh));
        max-height: calc(98 * var(--vh));
        border-radius: 5px;
    }

    #filter_data_container {
        height: fit-content;
        max-height: inherit;
        max-width: inherit;
        width: inherit;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        border: solid white;
        border-radius: calc(var(--vratio) * 2 * var(--vh));/*10px;*/
    }

    .inmobile  #filter_data_container {
        height: inherit;
        padding: 0px;
        justify-content: space-between
    }

    #exitArrow { /*TODO get rid of image*/
        position: absolute;
        top: calc(2 * var(--vh));
        left: calc(2 * var(--vh));
        width: calc(2 * var(--vh));
        height: calc(2 * var(--vh));
        cursor: pointer;
        font-size: 1.4em;
    }

    #exitArrow:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
    }

    #viewButton {
        width: 44%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .navArrow {
        cursor: pointer;
        font-size: 1.1em;
        width: 28%;
        margin: calc(.2 * var(--vh));
        display: flex;
        white-space: nowrap;
    }

    .toPreviousFilter {
        justify-content: flex-start;
    }

    .toNextFilter {
        justify-content: flex-end;
    }

    .navArrow:hover {
        color: var(--mccluskeyGold); /*#AF873F;*/
        white-space: nowrap;
    }

    .navArrow.notClickable {
        opacity: .4;
        cursor: initial;
    }

    .navArrow.notClickable:hover {
        color: #2c3e50;
    }

    .inmobile #exitArrow {
        top: calc(3 * var(--vh));
        right: calc(3* var(--vh));
    }

    #filter_data_container_title {
        font-size: 1.4em;
        font-weight: bolder;
        margin: calc(1.5 * var(--vh)) 0;
    }

    .inmobile #filter_data_container_title {
        margin: calc(2 * var(--vh)) 0;
    }

    #filterPopupFooter {
        margin-top: calc(1.5 * var(--vh));
    }

    .inmobile #filterPopupFooter {
        margin: calc(2 * var(--vh)) 0 calc(1 * var(--vh)) 0;
    }

    #filter_controls {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: calc(1 * var(--vh));
    }

    #CurrentFilterResults {
        margin-bottom: calc(1 * var(--vh));
    }

    #continue_results {
        background-color: var(--mccluskeyBlue);/*#0077C0;*//*#0079B6;*//*#AF873F;*/
        width: calc(12 * var(--vh));
        /*height: calc(2 * var(--vh));*/
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "myriad-pro", arial, sans-serif;
        font-weight: bolder;
        color: white;
        /*font-size: 2.1vf;*/
        padding: calc(.5 * var(--vh));
        border-radius: calc(var(--vratio) * var(--vh));/*5px;*/
    }

    .inmobile #continue_results {
        border-radius: 5px;
    }

    #continue_results:hover {
        background-position: bottom left;
        cursor: pointer;
        color: #2c3e50;
	}

    #filterSelectionDisplay {
        height: fit-content;
        padding: calc(1 * var(--vw));
    }

    .inmobile #filterSelectionDisplay {
        height: calc(74 * var(--vh));
        max-height: calc(74 * var(--vh));
    }

    .inmobile #filterSelectionDisplay.range {
        height: calc(37 * var(--vh));
    }
</style>
